import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Locale, detectBrowserLocale } from '@packages/global';

// 翻译资源 - 静态导入
import zhCommon from '@packages/global/i18n/locales/zh-CN/common.json';
import enCommon from '@packages/global/i18n/locales/en-US/common.json';
import zhNav from './locales/zh-CN/nav.json';
import enNav from './locales/en-US/nav.json';
import zhAuth from './locales/zh-CN/auth.json';
import enAuth from './locales/en-US/auth.json';
import zhApp from './locales/zh-CN/app.json';
import enApp from './locales/en-US/app.json';

// 新增命名空间 - project
import zhProject from './locales/zh-CN/project.json';
import enProject from './locales/en-US/project.json';

// 新增命名空间 - projectSettings
import zhProjectSettings from './locales/zh-CN/projectSettings.json';
import enProjectSettings from './locales/en-US/projectSettings.json';

// 新增命名空间 - script
import zhScript from './locales/zh-CN/script.json';
import enScript from './locales/en-US/script.json';

// 新增命名空间 - editor
import zhEditor from './locales/zh-CN/editor.json';
import enEditor from './locales/en-US/editor.json';

// 新增命名空间 - generation
import zhGeneration from './locales/zh-CN/generation.json';
import enGeneration from './locales/en-US/generation.json';

// 新增命名空间 - library
import zhLibrary from './locales/zh-CN/library.json';
import enLibrary from './locales/en-US/library.json';

// 新增命名空间 - common_ui
import zhCommonUi from './locales/zh-CN/common_ui.json';
import enCommonUi from './locales/en-US/common_ui.json';

// 新增命名空间 - creative
import zhCreative from './locales/zh-CN/creative.json';
import enCreative from './locales/en-US/creative.json';

// 新增命名空间 - avatar
import zhAvatar from './locales/zh-CN/avatar.json';
import enAvatar from './locales/en-US/avatar.json';

/** 读取持久化语言偏好，回退到浏览器检测 */
export function getInitialLocale(): Locale {
  try {
    const stored = localStorage.getItem('language-storage');
    if (stored) {
      const parsed = JSON.parse(stored) as { state?: { locale?: string } };
      if (parsed?.state?.locale) return parsed.state.locale as Locale;
    }
  } catch {
    // ignore - localStorage 不可用或数据损坏
  }
  return detectBrowserLocale();
}

i18n
  .use(initReactI18next)
  .init({
    lng: getInitialLocale(),
    fallbackLng: Locale.EN_US,
    defaultNS: 'common',
    resources: {
      [Locale.ZH_CN]: {
        common: zhCommon,
        nav: zhNav,
        auth: zhAuth,
        app: zhApp,
        project: zhProject,
        projectSettings: zhProjectSettings,
        script: zhScript,
        editor: zhEditor,
        generation: zhGeneration,
        library: zhLibrary,
        common_ui: zhCommonUi,
        creative: zhCreative,
        avatar: zhAvatar,
      },
      [Locale.EN_US]: {
        common: enCommon,
        nav: enNav,
        auth: enAuth,
        app: enApp,
        project: enProject,
        projectSettings: enProjectSettings,
        script: enScript,
        editor: enEditor,
        generation: enGeneration,
        library: enLibrary,
        common_ui: enCommonUi,
        creative: enCreative,
        avatar: enAvatar,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
